/* eslint-disable */
export default {
  mute: 'Stummschalten',
  unmute: 'Stummschaltung aufheben',
  hangup: 'Auflegen',
  reject: 'Ablehnen',
  hold: 'Halten',
  onHold: 'Wird gehalten',
  transfer: 'Weiterleiten',
  more: 'Mehr',
  stopRecord: 'Aufz. beend.',
  record: 'Aufnehmen',
  showKeypad: 'Wähltastatur',
  hideKeypad: 'Wähltastatur ausblenden',
  unHold: 'Wiederaufnehmen',
  forward: 'Weiterl.',
  ignore: 'Ignorieren',
  voicemail: 'An Voicemail',
  custom: 'Individuell gestalten',
  answerAndEnd: 'Antw. u. beenden',
  answerAndHold: 'Antw. u. halten',
  answer: 'Antworten',
  completeTransfer: 'Weiterleitung abschließen',
  reply: 'Antwort',
  add: 'Hinzufügen',
  mergeCall: 'Mit aktivem Anruf zusammenführen',
  endCallForEveryone: 'Anruf für alle beenden',
  leaveCall: 'Anruf verlassen',
  leaveOrEndCall: 'Anruf verlassen oder beenden?',
} as const;

// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"more"@#@ @source: @#@"More"@#@
// @key: @#@"stopRecord"@#@ @source: @#@"Stop Recording"@#@
// @key: @#@"record"@#@ @source: @#@"Record"@#@
// @key: @#@"showKeypad"@#@ @source: @#@"Keypad"@#@
// @key: @#@"hideKeypad"@#@ @source: @#@"Hide Keypad"@#@
// @key: @#@"unHold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"voicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"completeTransfer"@#@ @source: @#@"Complete transfer"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"mergeCall"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"endCallForEveryone"@#@ @source: @#@"End call for everyone"@#@
// @key: @#@"leaveCall"@#@ @source: @#@"Leave call"@#@
// @key: @#@"leaveOrEndCall"@#@ @source: @#@"Leave or end call?"@#@
